// removed by extract-text-webpack-plugin
module.exports = {"Button":"button__Button__7xIeg","Success":"button__Success__32CY9","Danger":"button__Danger__2c8OA","Grey":"button__Grey__1rXJ0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/button/button.css
// module id = 128
// module chunks = 3